import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  get(params) {
    return axios.get(this.url, { params });
  }

  disconnect(id) {
    return axios.post(`${this.url}/${id}/disconnect`);
  }
}

export default new Agents();
